"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function getSalaryNumber(employee) {
    var salaryString = employee.dataset.salary.slice(1).replaceAll(",", "");
    return +salaryString;
}
function sortList(list) {
    var _list;
    var employeesArray = _to_consumable_array(list.children);
    var newemployeesArray = employeesArray.sort(function(a, b) {
        var childA = getSalaryNumber(a);
        var childB = getSalaryNumber(b);
        return childB - childA;
    });
    (_list = list).append.apply(_list, _to_consumable_array(newemployeesArray));
}
function getEmployees(list) {
    var workerArray = _to_consumable_array(list.children);
    return workerArray.map(function(worker) {
        return {
            name: worker.dataset.name,
            position: worker.dataset.position,
            salary: getSalaryNumber(worker),
            age: +worker.dataset.age
        };
    });
}
var mainList = document.querySelector("ul");
sortList(mainList);
var employees = getEmployees(mainList);
// eslint-disable-next-line no-console
console.log(employees);

//# sourceMappingURL=index.bd9a6d4b.js.map
